module.exports = __webpack_public_path__ + "media/3_4-5.4b4ddc9f.mp3";